import "./Parallax.css";
import React, { useEffect } from "react";

const ParallaxImage = ({ containerClassName, imageClassName, src, alt }) => {
  useEffect(() => {
    const container = document.querySelector(`.${containerClassName}`);
    const leftImage = document.querySelector(`.${imageClassName}`);

    if (!container || !leftImage) {
      console.error(
        `Element '.${containerClassName}' or '.${imageClassName}' not found`
      );
      return;
    }

    const handleMouseMove = (event) => {
      const { left, top, width, height } = container.getBoundingClientRect();
      const { clientX, clientY } = event;

      const maxRotateX = 7; // Максимальный наклон по X
      const maxRotateY = 10; // Максимальный наклон по Y

      if (
        clientX < left ||
        clientX > left + width ||
        clientY < top ||
        clientY > top + height
      ) {
        leftImage.style.transform = `scale(1) rotateX(0deg) rotateY(0deg)`;
        return;
      }

      const x = (clientX - left) / width - 0.5;
      const y = (clientY - top) / height - 0.5;

      const rotateX = y * maxRotateX;
      const rotateY = x * maxRotateY * -1;

      leftImage.style.transform = `scale(1.05) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    };

    const handleMouseLeave = () => {
      leftImage.style.transform = `scale(1) rotateX(0deg) rotateY(0deg)`;
    };

    container.addEventListener("mousemove", handleMouseMove);
    container.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      container.removeEventListener("mousemove", handleMouseMove);
      container.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [containerClassName, imageClassName]);

  return (
    <div className={containerClassName}>
      <img className={imageClassName} src={src} alt={alt} />
    </div>
  );
};

export default ParallaxImage;
